import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setError, setSuccess, setInfo } from '../redux/states';

export const useErrorSetter = () => {
  const dispatch = useDispatch();
  return useCallback((message) => {
    dispatch(setError({ state: true, message, ts: Date.now() }));
  }, [dispatch]);
};

export const useSuccessSetter = () => {
  const dispatch = useDispatch();
  return useCallback((message) => {
    dispatch(setSuccess({ state: true, message, ts: Date.now() }));
  }, [dispatch]);
};

export const useInfoSetter = () => {
  const dispatch = useDispatch();
  return useCallback((message) => {
    dispatch(setInfo({ state: true, message, ts: Date.now() }));
  }, [dispatch]);
};